import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_DESCRIPTION = 'An AI-assisted reflection and decision-support tool for organising thoughts and exploring options.';

const ROUTE_META: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'Sanjeom — Think clearly, move deliberately',
    description: DEFAULT_DESCRIPTION,
  },
  '/pricing': {
    title: 'Pricing | Sanjeom',
    description: 'One-time AI question packs with clear, fixed USD pricing.',
  },
  '/workspace': {
    title: 'Private AI workspace | Sanjeom',
    description: 'A private workspace for AI-assisted reflection, clearer thinking, and exploring options.',
  },
  '/checkout': {
    title: 'Secure checkout | Sanjeom',
    description: 'Review a Sanjeom question pack before continuing to secure Stripe Checkout.',
  },
  '/checkout/complete': {
    title: 'Payment confirmation | Sanjeom',
    description: 'Confirm a completed Sanjeom question-pack payment.',
  },
  '/login': {
    title: 'Sign in | Sanjeom',
    description: 'Sign in to your private Sanjeom AI workspace and conversation history.',
  },
  '/support': {
    title: 'Support | Sanjeom',
    description: 'Support for Sanjeom accounts, question packs, payments and refunds.',
  },
  '/terms': {
    title: 'Terms of Service | Sanjeom',
    description: 'Terms governing Sanjeom and one-time AI question packs.',
  },
  '/privacy': {
    title: 'Privacy Policy | Sanjeom',
    description: 'How GHOSTPROBE LTD handles personal information for Sanjeom.',
  },
  '/refund-policy': {
    title: 'Refund Policy | Sanjeom',
    description: 'How Sanjeom handles digital-service cancellations, service failures and refunds.',
  },
};

export function RouteMeta() {
  const location = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[location.pathname] ?? {
      title: 'Page not found | Sanjeom',
      description: DEFAULT_DESCRIPTION,
    };
    document.title = meta.title;

    const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (description) description.content = meta.description;

    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.href = new URL(location.pathname, 'https://sanjeom.co.uk').toString();
  }, [location.pathname]);

  return null;
}
